export default __webpack_public_path__ + "static/media/main3.179380db.png";